import { render, staticRenderFns } from "./RelatedCompany.vue?vue&type=template&id=cdceed28&"
import script from "./RelatedCompany.vue?vue&type=script&lang=js&"
export * from "./RelatedCompany.vue?vue&type=script&lang=js&"
import style0 from "./RelatedCompany.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports